import DoAPICall from './DoAPICall'

//Create User role
export async function createUserGroup(userToken, userGroup){
    const apiPayload = {
        httpMethod:'post',
        userToken,
        uri:'usergroups',
        payLoad:{
                user_id:userGroup.user_id,
                group_id:userGroup.group_id
            },
        requestOptions:{}
    }
    return DoAPICall(apiPayload)
}

//Get All role
export async function getUserGroups(userToken){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'usergroups',
        payLoad:{},
        requestOptions:{}
    }
    return DoAPICall(apiPayload)
}

//Get One User Role
export async function getUserGroup(userToken, id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'usergroups/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return DoAPICall(apiPayload)
}

//Update User Role
export async function updateUserGroup(userToken, userGroup){
    const apiPayload = {
        httpMethod:'put',
        userToken,
        uri:'usergroups/'+userGroup.id,
        payLoad:{
                user_id:userGroup.user_id,
                group_id:userGroup.group_id,
            },
        requestOptions:{}
    }
    return DoAPICall(apiPayload)
}

//Delete User Role
export async function deleteUserGroup(userToken, id){
    const apiPayload = {
        httpMethod:'delete',
        userToken,
        uri:'usergroups/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return DoAPICall(apiPayload)
}


